import * as types from "../../store/mutation-types";
import axios from "axios";
import {  update_profile } from "../../store/api/api";
import i18n from "../../mixins/i18n"

const state = {
  isLoadingData: false,

  city_list: null,
  loading_city_list: false,

  form_data: {
    fullname: null,
    gender: null, // Nam/Nữ
    date_of_birth: null,  //
    marriage_status: null, // Độc thân / Đã kết hôn 

    id_number: null,
    id_issue_date: null,
    id_issue_place: null,
    id_native_place: null,

    id_address: null,
    current_address: null,
    family_reg_address: null,

    vehicle_type: null,
    driving_license: null, 
    plate_number: null,

    relatives: [],
    is_valid: true
  }  
};
const getters = {
  cityList: state => state.city_list,
  formData: state => state.form_data,
  isValidFormData: state => {
    const formData = state.form_data
    let result = {
      message: '',
      value: true
    }
    for (let key in formData) {
      if (!formData[key] || (formData[key].length !== 2) && key === 'relatives') {
        return {
          message: "Trường bắt buộc : " + i18n.t("driver_onboarding.profile.field." + key),
          value: false
        }
      }
    }
    return result
  }
};

const actions = {
  loadCityList({ state, commit }) {
    return new Promise((resolve, reject) => {
      if (state.loading_city_list) resolve();

      state.loading_city_list = true
      const url = `${window.location.origin}/vn.json`;
      axios
        .get(url)
        .then(response => {
          state.loading_city_list = false
          commit(types.SET_CITY_LIST, response.data);
          resolve(response);
        })
        .catch(error => {
          state.loading_city_list = false
          reject(error);
        });
    });
  },

  // eslint-disable-next-line 
  async updateProfile({ commit }, data) {
    return new Promise((resolve, reject) => {
      // const url = `${process.env.VUE_APP_BASE_URL}/vietnamese-data.json`;
      update_profile(data)
        .then(response => {
          if (response) {
            // commit(types.SET_DATA_PROFILE, response);
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },

  setProfileFormData ({ commit }, data) {
    commit(types.SET_GENERAL_PROFILE, data)
    commit(types.SET_IDENTITY_PROFILE, data)
    commit(types.SET_ADDRESS_PROFILE, data)
    commit(types.SET_VEHICLE_PROFILE, data)
    // commit(types.SET_RELATIVE_PROFILE, data)
  },
  setGeneralProfile ({ commit }, data) {
    commit(types.SET_GENERAL_PROFILE, data)
  },
  setIdentityProfile ({ commit }, data) {
    commit(types.SET_IDENTITY_PROFILE, data)
  },
  setAddressProfile ({ commit }, data) {
    commit(types.SET_ADDRESS_PROFILE, data)
  },
  setVehicleProfile({commit}, data){
    commit(types.SET_VEHICLE_PROFILE, data)
  },
  setRelativeProfile ({ commit }, data) {
    commit(types.SET_RELATIVE_PROFILE, data)
  }
};
const mutations = {
  [types.SET_CITY_LIST](state, data) {
    state.city_list = data;
  },
  [types.SET_GENERAL_PROFILE](state, data) {
    state.form_data.fullname = data.fullname
    state.form_data.gender = data.gender
    state.form_data.date_of_birth = data.date_of_birth
    state.form_data.marriage_status = data.marriage_status
  },
  [types.SET_IDENTITY_PROFILE](state, data) {
    state.form_data.id_number = data.id_number
    state.form_data.id_issue_date = data.id_issue_date
    state.form_data.id_issue_place = data.id_issue_place
    state.form_data.id_native_place = data.id_native_place
  },
  [types.SET_ADDRESS_PROFILE](state, data) {

    state.form_data.id_address = data.id_address
    state.form_data.current_address = data.current_address
    state.form_data.family_reg_address = data.family_reg_address
  },
  [types.SET_VEHICLE_PROFILE](state, data) {   
    state.form_data.vehicle_type = data.vehicle_type
    state.form_data.driving_license = data.driving_license
    state.form_data.plate_number = data.plate_number
  },
  [types.SET_RELATIVE_PROFILE](state, data) {
    state.form_data.relatives = data
  }  
};

export default {
  state,
  mutations,
  actions,
  getters
};
